import { INewsDetails } from 'models/News/INewsDetails'

export interface DetailsProps {
  details: INewsDetails[]
  isAr: boolean
  styles: {
    readonly [key: string]: string
  }
}

export const useDetails = (props: DetailsProps) => {
  return {
    ...props,
  }
}
